import { FC, useState } from 'react'
import { useAuth } from 'hooks'

import { TableFooter } from 'components'
import {
  TableContainerStyled,
  TableCellStyled,
  TableRowStyled,
  TableStyled
} from 'components'
import { BlockIcon, EditIcon, LinkIcon, StatusIcon } from 'components/Icons'
import { SPACING, FORMAT, COLORS } from 'utils'
import { UsuarioFornecedor } from 'utils/types'

import { TypeHandleUser } from '../../Users'
import { TableBody, TableHead } from './TableAcessos.styles'
import { Tooltip } from '@material-ui/core'

interface ITableAcessos {
  tableData: UsuarioFornecedor[]
  setSelectedUser: (user: UsuarioFornecedor, type: TypeHandleUser) => void
  isAdmin?: boolean
}
export const TableAcessos: FC<ITableAcessos> = ({
  tableData,
  setSelectedUser,
  isAdmin
}) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(15)
  const { user } = useAuth()

  const loggedUserId = user?.IdUsuario

  const handleChangePage = (newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleStatus = (status: string) => {
    if (status === 'Green' || status === 'Aprovado' || status === 'Liberado' || status === 'L') return 'Liberado'
    if (status === 'Yellow' || status === 'Analisar' || status === 'Analisando' || status === 'PendenteDocumento' || status === 'P') return 'Aguardando validação'
    if (status === 'Red' || status === 'Recusado' || status === 'B') return 'Recusado'
    return 'Desativado'
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHead>
            <TableRowStyled>
              <TableCellStyled>CPF/Passaporte</TableCellStyled>
              <TableCellStyled>Colaborador</TableCellStyled>
              <TableCellStyled>Contato</TableCellStyled>
              <TableCellStyled>E-mail</TableCellStyled>
              <TableCellStyled align="center">Validade Acesso</TableCellStyled>
              <TableCellStyled>Perfil</TableCellStyled>
              <TableCellStyled align="center" padding="checkbox">
                Status
              </TableCellStyled>
              <TableCellStyled align="center">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? tableData?.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
              : tableData
            )?.map((row) => {
              const isRowAdmin =
                row?.usuario?.idUsuario === row?.usuarioIdAdministrador

              const isLoggedUserAdmin =
                !!loggedUserId && loggedUserId === row?.usuarioIdAdministrador

              const isActionDisabled =
                (isRowAdmin && !isLoggedUserAdmin) ||
                row?.flSituacao === 'D' ||
                row?.flSituacao === 'B' ||
                isAdmin === false

              return (
                <TableRowStyled key={row?.idUsuarioFornecedor.toString()}>
                  <TableCellStyled>
                    {FORMAT.documento(row?.usuario.cdDocto.trim()) ||
                      '- - - - - - -'}
                  </TableCellStyled>
                  <TableCellStyled>
                    {row?.usuario?.nmUsuario || '- - - - - - -'}
                  </TableCellStyled>
                  <TableCellStyled>
                    {FORMAT.contatoInternacional(row.usuario.nuContato) ||
                      '- - - - - - -'}
                  </TableCellStyled>
                  <TableCellStyled>
                    {row?.usuario?.txEmail || '- - - - - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.dtValidade
                      ? FORMAT.formatDDMMYYYY(row.dtValidade)
                      : '- - - - - - -'}
                  </TableCellStyled>
                  <TableCellStyled>
                    {row?.usuario?.perfilUsuario?.txDenominacao ||
                      '- - - - - - -'}
                  </TableCellStyled>
                  <Tooltip
                    arrow
                    title={handleStatus(row?.flSituacao)}
                    placement='left'
                  >
                    <TableCellStyled>
                      <StatusIcon
                        value={row?.flSituacao}
                        marginLeft="auto"
                        marginRight="auto"
                      />
                    </TableCellStyled>
                  </Tooltip>
                  <TableCellStyled align="center">
                    <LinkIcon
                      colorIcon={isActionDisabled ? COLORS.gray : COLORS.black}
                      cursor={isActionDisabled ? 'default' : 'pointer'}
                      onClick={
                        isActionDisabled
                          ? null
                          : () => setSelectedUser(row, 'contract')
                      }
                      marginRight={SPACING.spacing10}
                    />

                    <EditIcon
                      colorIcon={isActionDisabled ? COLORS.gray : COLORS.black}
                      cursor={isActionDisabled ? 'default' : 'pointer'}
                      onClick={
                        isActionDisabled
                          ? null
                          : () => setSelectedUser(row, 'edit')
                      }
                      marginRight={SPACING.spacing10}
                    />

                    <BlockIcon
                      colorIcon={isActionDisabled ? COLORS.gray : COLORS.error}
                      cursor={isActionDisabled ? 'default' : 'pointer'}
                      onClick={
                        isActionDisabled
                          ? null
                          : () => setSelectedUser(row, 'block')
                      }
                    />
                  </TableCellStyled>
                </TableRowStyled>
              )
            })}
          </TableBody>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
    </>
  )
}